export default "__VITE_ASSET__CXX5_K2k__"